<template>
    <page-list-container class="sleep-report" :total="total" :pageSize="pageSize" :inputCurrentPage="currentPage"
        :emptyInfo="''"
        @onPageChange="onPageChange" @onSizeChange="onSizeChange">
        <!-- 表格 -->
        <el-table :data="reportArray" style="width: 100%" :row-class-name="getRowClassName"
            :header-cell-style="{ height: '50px', padding: '0', backgroundColor: '#fafafa' }"
            :cell-style="{ textAlign: 'center', padding: '8px', height: '54px' }" :row-style="{ height: '54px' }"
            @row-click="onRowClick">

            <el-table-column prop="trueName" label="姓名" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ getDisplayName(scope.row.trueName) }}
                </template>
            </el-table-column>

            <el-table-column v-if="shouldShowMedicalRecord" prop="mzh" label="病案号" width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ getDisplayValue(scope.row.mzh) }}
                </template>
            </el-table-column>

            <el-table-column label="AHI/OAHI" width="160">
                <template slot="header">
                    <div class="header-with-filter">
                        <span>AHI/OAHI</span>
                        <el-select v-model="selectedAHILevelIndex" @change="onAHILevelChange" size="mini"
                            placeholder="筛选" style="width: 70px;">
                            <el-option v-for="(item, index) in AHILevelArray" :key="index" :label="item"
                                :value="index"></el-option>
                        </el-select>
                    </div>
                </template>
                <template slot-scope="scope">
                    <span :style="{ color: getAhiColor(scope.row) }">
                        {{ getAhiInfo(scope.row) }}
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="sn" label="设备SN" width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ getSnDisplay(scope.row) }}
                </template>
            </el-table-column>

            <el-table-column label="报告生成时间" width="160">
                <template slot-scope="scope">
                    {{ getRecordDay(scope.row) }}
                </template>
            </el-table-column>

            <el-table-column prop="hospitalName" label="机构" :min-width="shouldShowMedicalRecord ? 290 : 360" show-overflow-tooltip>
                <template slot-scope="scope">  
                    
                    {{ getDisplayValue(scope.row.hospitalName) }}
                </template>
            </el-table-column>

            <el-table-column label="完整性" width="160">
                <template slot="header">
                    <div class="header-with-filter">
                        <span>完整性</span>
                        <el-select v-model="selectedCompletenessIndex" @change="onCompletenessChange" size="mini"
                            placeholder="筛选" style="width: 70px;">
                            <el-option v-for="(item, index) in completenessArray" :key="index" :label="item"
                                :value="index"></el-option>
                        </el-select>
                    </div>
                </template>
                <template slot-scope="scope">
                    <el-popover placement="top" width="350" trigger="hover">
                        <div class="popbox">
                            <div class="popbox-monitorTime">
                                <span>{{ getMonitorTime(scope.row) }}</span>
                                <span style="color: #F45C50;" v-if="isLessThan4Hours(scope.row)">（&lt4小时）</span>
                            </div>
                            <div class="popbox-sleepTime">
                                <span>{{ getSleepTime(scope.row) }}</span>
                                <span style="color: #F45C50;" v-if="isLessThan3Hours(scope.row)">（&lt3小时）</span>
                            </div>
                            <div class="popbox-create">
                                {{ getCreateTime(scope.row) }}
                            </div>
                        </div>
                        <div slot="reference">
                            <div style="text-align: center;">
                                <p :style="{ color: getCompletenessColor(scope.row) }">{{ getCompleteness(scope.row) }}
                                </p>
                                <p v-if="getCompletenessTip(scope.row)"
                                    :style="{ color: getCompletenessColor(scope.row) }">
                                    {{ getCompletenessTip(scope.row) }}
                                </p>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column v-if="isSeniorAdministrator" label="异常标记" width="220">
                <template slot="header">
                    <div class="header-with-filter">
                        <span>异常标记</span>
                        <el-cascader v-model="selectedExceptionFilter" :options="exceptionOptions"
                            :props="cascaderProps" :show-all-levels="false" clearable size="mini" placeholder="筛选"
                            style="width: 90px;" @change="onFilterExceptionChange">
                        </el-cascader>
                    </div>
                </template>
                <template slot-scope="scope">
                    <el-cascader :value="getInvalidReportSubStatus(scope.row)" :options="exceptionOptions"
                        :props="cascaderProps" :show-all-levels="false" size="mini"
                        @change="onExceptionChange(scope.row, $event)">
                    </el-cascader>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="scope">
                    <div class="operation-buttons">
                        <el-button v-if="scope.row.reportDeleted == '1'" type="text" style="color: #f45c50;"
                            @click.stop="onDelete(scope.row)">
                            删除
                        </el-button>

                        <el-button type="text" :disabled="!isShowButton(scope.row)"
                            @click.stop="onPreviewClick(scope.row)">
                            <i class="el-icon-view"></i> 查看
                        </el-button>

                        <el-button type="text" :disabled="!isShowButton(scope.row)"
                            @click.stop="onDownloadClick(scope.row)">
                            <i class="el-icon-download"></i> 下载
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </page-list-container>
</template>

<script>

import Pagination from "@c/common/pagination2.vue";
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";

import { exportReport } from "@js/report-export-tool.js";
import { DateTool } from "@js/date-tool.js";
import { ReportPreviewTool } from "@js/report-preview-tool.js";
import { getDisplayName } from "@js/anonymization-tool.js";
export default {
    components: {

        PageListContainer,
        Pagination,
    },

    props: {
        componentDuration: Object,
        modeType: {
            type: [Number, null],
            default: null,
        },
    },

    data: function () {
        return {
            //deviceList
            reportArray: [],
            total: undefined, // 显示总条数
            pageSize: undefined, // 每页显示条数
            currentPage: 1, // 当前的页数
            keywords: undefined,
            //item-bar
            selectedAHILevelIndex: 0,
            selectedCompletenessIndex: 0,
            //table
            selectedID: undefined,
            exceptionOptions: [],
            exceptionClassifyIds: [],
            selectedExceptionFilter: [],
            cascaderProps: {
                value: 'id',
                label: 'tagName',
                children: 'children'
            }

        };
    },

    mounted() {
        this.pageSize = bestPageSizeComputer()
        this.reportListRequest();
        this.getSleepExceptionClassifyList()
    },

    watch: {
        hospitalID: function () {
            this.currentPage = 1;
            this.selectedAHILevelIndex = 0;
            this.selectedCompletenessIndex = 0;
            this.reportListRequest();
        },

        componentDuration() {
            this.currentPage = 1;
            this.selectedAHILevelIndex = 0;
            this.selectedCompletenessIndex = 0;
            this.reportListRequest();
        }
    },

    methods: {
        exportReport(exportParams = {}) {
            const params = {
                startTime: this.componentDuration.startTime,
                endTime: this.componentDuration.endTime,
                keywords: this.keywords,
                ahi: this.ahi == 0 ? null : this.ahi,
                hospitalId: this.hospitalID == 0 ? null : this.hospitalID,
                complete: this.complete == 0 ? null : this.complete,
                modeType: exportParams.modeType,
                exceptionClassifyIds: exportParams.exceptionClassifyIds
            };
            exportReport(params);
        },

        onAHILevelChange: function () {
            this.currentPage = 1;
            if (this.selectedAHILevelIndex == 0) {
                this.selectedCompletenessIndex = 0;
            } else {
                this.selectedCompletenessIndex = 1; //AHI是完整的报告
            }
            this.reportListRequest();
        },

        onCompletenessChange: function () {
            this.currentPage = 1;
            this.reportListRequest();
        },

        onRowClick: function (row) {
            this.selectedID = row.id;
        },

        onSearchClick(keywords) {
            this.keywords = keywords;
            this.currentPage = 1;
            this.selectedAHILevelIndex = 0;
            this.selectedCompletenessIndex = 0;
            this.reportListRequest();
        },

        onModeTypeChange(modeType) {
            this.currentPage = 1;
            this.reportListRequest();
        },

        async onDeleteReport(id) {
            try {
                const params = {
                    "id": id
                }
                await this.$api.deleteRequest(params)
                this.reportListRequest();
            } catch (error) {
                this.$toast.showRed(error);
            }
        },

        //分页
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.reportListRequest();
        },

        onSizeChange(size) {
            this.pageSize = size
            this.currentPage = 1
            this.reportListRequest();
        },

        async reportListRequest() {
            try {
                const params = {
                    "keyWords": this.keywords,
                    "pageNum": this.currentPage,
                    "hospitalId": this.hospitalID,
                    "pageSize": this.pageSize,
                    "startTime": this.componentDuration.startTime,
                    "endTime": this.componentDuration.endTime,
                    "complete": this.selectedCompletenessIndex,
                    "ahi": this.selectedAHILevelIndex,
                    "exceptionClassifyIds": this.exceptionClassifyIds,
                    "modeType": this.modeType
                }
                const response = await this.$api.getSleepReportPageList(params)
                this.total = response.total;
                this.reportArray = response.list;
            } catch (error) {
                this.$toast.showRed(error);
            }
        },

        async getSleepExceptionClassifyList() {
            try {
                const response = await this.$api.getSleepExceptionClassifyList({})
                const exceptionOptions = [{
                    id: -3,
                    tagName: '人为',
                    children: []
                },
                {
                    id: -2,
                    tagName: '硬件',
                    children: []
                },
                {
                    id: -1,
                    tagName: '其他',
                    children: []
                }]
                response.forEach(item => {
                    if (item.pid == 0) {
                        exceptionOptions[0].children.push(item)
                    } else if (item.pid == 1) {
                        exceptionOptions[1].children.push(item)
                    } else {
                        exceptionOptions[2].children.push(item)
                    }
                })
                this.exceptionOptions = exceptionOptions
            } catch (error) {
                this.$toast.showRed(error);
            }
        },
        async onExceptionChange(item, event) {
            try {
                const params = {
                    id: item.reportExceptionId,
                    reportId: item.id,
                    tagPid: event[0] + 3,
                    tagId: event[1]
                }
                if (params.id != null) {
                    await this.$api.updateSleepExceptionClassify(params)
                } else {
                    await this.$api.addSleepExceptionClassify(params)
                }
                this.reportListRequest();
            } catch (error) {
                this.$toast.showRed(error);
            }
        },
        onFilterExceptionChange(event) {
            this.selectedExceptionFilter = event || [];
            if (event.length > 0) {
                this.exceptionClassifyIds = [event[1]];
            } else {
                this.exceptionClassifyIds = [];
            }
            this.currentPage = 1;
            this.reportListRequest();
        },

        // 表格相关方法
        getRowClassName({ row }) {
            return row.id === this.selectedID ? 'selected-row' : '';
        },

        getDisplayValue(value) {
            return placeholderText(value);
        },

        getDisplayName(value) {
            return getDisplayName(value, this.$store.state.accountInfo);
        },

        getSnDisplay(row) {
            const sn = this.getDisplayValue(row.sn);
            const { deviceType } = row;
            
            if (deviceType === 0) {
                return sn;
            } else if (deviceType === 1) {
                return sn + ' pro+';
            } else if (deviceType === 2) {
                return sn + ' pro';
            }
            return sn;
        },

        getRecordDay(row) {
            return placeholderText(DateTool.millisecondTimestampToStr(row.recordDay, "Y-M-D h:m"));
        },

        getAhiInfo(row) {
            const isValid = row.complete == "完整";
            if (isValid && row.ahi>=0) {
                return `${row.ahi}（${row.ahiLevel}）`;
            } else {
                return "-";
            }
        },

        getAhiColor(row) {
            const isValid = row.complete == "完整";
            if (isValid) {
                const ahiLevel = row.ahiLevel;
                switch (ahiLevel) {
                    case "正常":
                        return "#6cc291";
                    case "轻度":
                        return "#666666";
                    case "中度":
                        return "#325FAC";
                    default:
                        return "#f45c50";
                }
            } else {
                return "#666666";
            }
        },

        getCompleteness(row) {
            const isValid = row.complete == "完整";
            return isValid ? "是" : "无效报告";
        },

        getCompletenessColor(row) {
            const isValid = row.complete == "完整";
            return isValid ? "#666666" : "#f45c50";
        },

        getCompletenessTip(row) {
            const isValid = row.complete == "完整";
            if (isValid) {
                return "";
            } else {
                if ((row.complete == "缺少血氧" || row.complete == "睡眠时间不足") && row.invalidReportSubStatus && this.$store.getters.isSeniorAdministrator) {
                    return `（${row.invalidReportSubStatus}）`;
                } else if (row.complete == "缺少血氧" && row.invalidReportSubStatus === '缺血氧请重启') {
                    return `（${row.invalidReportSubStatus}）`;
                } else {
                    return `（${row.complete}）`;
                }
            }
        },

        getMonitorTime(row) {
            return "开始记录时间~结束记录时间：" + placeholderText(DateTool.millisecondTimestampToStr(row.startSleepTime, "M月D日 h:m")) + " ~ " + placeholderText(DateTool.millisecondTimestampToStr((row.startSleepTime + row.extraCheckTimeMinute * 60 * 1000), "M月D日 h:m"));
        },

        getSleepTime(row) {
            const totalMinutes = row.remTime + row.lightSleepTime + row.deepSleepTime;
            const hour = parseInt(totalMinutes / 60);
            const minute = totalMinutes - hour * 60;
            return `睡眠时长（TST）:${hour}小时${minute}分钟`;
        },

        getCreateTime(row) {
            return "报告上传时间：" + placeholderText(DateTool.millisecondTimestampToStr(row.createDat, "Y-M-D h:m:s"));
        },

        isLessThan4Hours(row) {
            const distanceMillSeconds = row.extraCheckTimeMinute;
            return distanceMillSeconds < 240;
        },

        isLessThan3Hours(row) {
            const totalMinutes = row.remTime + row.lightSleepTime + row.deepSleepTime;
            const hour = parseInt(totalMinutes / 60);
            return hour < 3;
        },

        getInvalidReportSubStatus(row) {
            if (row.reportExceptionId) {
                return [row.exceptionTagPid - 3, row.exceptionTagId];
            }
            return [];
        },

        isShowButton(row) {
            const isOxygenDeficiencyView = row.oxygenDeficiencyView == "1";
            if (isOxygenDeficiencyView) {
                return row.complete == "完整" || row.complete == "缺少血氧";
            } else {
                return row.complete == "完整";
            }
        },


        onDelete(row) {
            this.$alert.show("报告操作", "是否要删除报告？", () => {
                this.onDeleteReport(row.id);
            });
        },

        onPreviewClick(row) {
            if (this.isShowButton(row)) {
                const { deviceType } = row;
                if (deviceType === 0) {
                    ReportPreviewTool.previewReport(
                        row.trueName,
                        row.reportNumber,
                        row.createDat,
                        deviceType,
                    );
                } else {
                    ReportPreviewTool.previewNewReport(
                        row.trueName,
                        row.reportNumber,
                        row.createDat,
                        deviceType,
                    );
                }
            }
        },

        onDownloadClick(row) {
            if (this.isShowButton(row)) {
                if (row.pdfUrl == null) {
                    this.reportGenerateUrl(row);
                } else {
                    ReportPreviewTool.downloadReport(
                        row.trueName,
                        row.pdfUrl,
                        row.createDat
                    );
                }
            }
        },


        async reportGenerateUrl(row) {
            try {
                const params = {
                    reportId: row.id,
                };
                const response = await this.$api.reportGenerateUrl(params);
                row.pdfUrl = response.pdfUrl;
                this.onDownloadClick(row);
            } catch (error) {
                this.$toast.showRed(error);
            }
        }
    },

    computed: {
        hospitalID: function () {
            return this.$store.state.selectedHospital.hospitalid;
        },

        ahi: function () {
            return getObjectValues(AHI_LEVEL_CODE)[this.selectedAHILevelIndex];
        },

        complete: function () {
            return getObjectValues(REPORT_COMPLETENESS_REQUEST_CODE)[
                this.selectedCompletenessIndex
            ];
        },

        isSeniorAdministrator() {
            return this.$store.getters.isSeniorAdministrator;
        },

        shouldShowMedicalRecord() {
            return this.$store.state.selectedHospital.hospitalid === 599;
        },

        AHILevelArray: function () {
            return getObjectKeys(AHI_LEVEL_CODE);
        },

        completenessArray: function () {
            return getObjectKeys(REPORT_COMPLETENESS_REQUEST_CODE);
        },
    },
};
</script>

<style lang="scss" scoped>
.sleep-report {
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    // 表格容器自适应宽度
    :deep(.page-list-container) {
        overflow-x: auto;
        
        .el-table {
            // 移除固定最小宽度，让表格根据实际内容宽度自适应
            // 只有当内容真正超出容器时才显示滚动条
            min-width:1500px;
        }
    }

    &-list {
        width: 100%;
    }

    &-empty-info {
        color: rgba($color: black, $alpha: 0.85);
        font-size: rem(14);
        width: 100%;
        margin-top: rem(100);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &-pagination {
        width: 100%;
        height: rem(90);
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.operation-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    flex-wrap: nowrap;
    height: 54px !important;
    min-height: 54px !important;
    max-height: 54px !important;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;

    .el-button {
        padding: 3px 4px;
        margin: 0;
        font-size: 14px;
        line-height: 1;
        height: auto;
        flex-shrink: 1;
        white-space: nowrap;
        min-width: 0;
    }
}

.popbox {
    font-size: 12px;
    color: #817889;

    &-sleepTime {
        margin-top: 3px;
    }

    &-create {
        margin-top: 3px;
    }
}

// 表格选中行样式
:deep(.selected-row) {
    background-color: #e6f7ff !important;

    &:hover {
        background-color: #e6f7ff !important;
    }
}

// 表头筛选器样式
.header-with-filter {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    height: 100%;

    span {
        font-weight: bold;
        color: #606266;
        white-space: nowrap;
        font-size: 13px;
        flex-shrink: 0;
    }

    .el-select,
    .el-cascader {
        font-size: 12px;
        flex-shrink: 0;
    }
}

// 调整表头样式
:deep(.el-table__header-wrapper) {
    background-color: #fafafa;

    .el-table__header {
        .el-table__cell {
            height: 50px;
            padding: 0;
            background-color: #fafafa;
            border-bottom: 1px solid #e8e8e8;

            .cell {
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 8px;
                line-height: 1;
            }
        }
    }
}

// 确保表头文字对齐
:deep(.el-table__header) {
    th {
        background-color: #fafafa !important;
        text-align: center;

        .cell {
            text-align: center;
        }
    }
}

// 表格整体样式
:deep(.el-table) {
    .el-table__body-wrapper {
        .el-table__body {
            .el-table__row {
                height: 54px !important;

                .el-table__cell {
                    text-align: center;
                    border-bottom: 1px solid #e8e8e8;
                    height: 54px !important;

                    .cell {
                        text-align: center;
                        padding: 8px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 54px !important;
                        box-sizing: border-box;
                    }
                }
            }
        }
    }
}

// 固定操作列的样式
:deep(.el-table__fixed-right) {
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);

    .el-table__header-wrapper {
        background-color: #fafafa;
    }

    .el-table__body-wrapper {
        .el-table__body {
            .el-table__row {
                height: 54px !important;

                .el-table__cell {
                    text-align: center;
                    border-bottom: 1px solid #e8e8e8;
                    height: 54px !important;

                    .cell {
                        text-align: center;
                        padding: 8px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 54px !important;
                        box-sizing: border-box;
                    }
                }
            }
        }
    }
}
</style>
